import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 150.9 150.9",
  style: {"enable-background":"new 0 0 150.9 150.9"},
  "xml:space": "preserve"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("rect", {
    class: "st0",
    width: "150.9",
    height: "150.9"
  }),
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("polygon", {
      class: "st1",
      points: "75.4,99 55.1,78.7 55.8,78 75.4,97.6 95,78 95.7,78.7 \t\t"
    }),
    /*#__PURE__*/_createElementVNode("rect", {
      x: "74.9",
      y: "47.2",
      class: "st1",
      width: "1",
      height: "51.1"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "header__button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ]))
}